import {CmnComp} from "../../common/CmnComp"
import section04Styles from "./section04.module.css"

const data = {
	title: "",
	header: "Benefits of Bazi",
	description:
		"Empower you to recognize your strengths, weaknesses and the opportunity to mitigate your challenges. \n Emphasize that your chart is a guide, not a limitation. \nShow that transformation begins with a single, intentional thought.",
	button: "Discover Gloam",
}

export const Section04 = () => {
	return (
		<section
			id="4"
			className={section04Styles.section04}
		>
			<div>
				<img
					src="./Images/Aesop_section04_image.avif"
					alt="section04"
				/>
			</div>
			<div>
				<CmnComp props={data} />
			</div>
		</section>
	)
}
